import React from "react";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";

const Paginator = props => {
	let offsetTo = props.page * props.pageLimit;
	let offsetFrom = offsetTo - props.pageLimit + 1;
	if (offsetTo > props.total) {
		offsetTo = props.total;
	}
	return (
		<div style={{ display: "flex", justifyContent: "center" }}>
			<Pagination
				className="ant-pagination"
				onChange={props.onChangePage}
				current={props.page}
				showTotal={() =>
					`${offsetFrom} - ${offsetTo} de ${props.total} registros`}
				total={props.total}
				pageSize={props.pageLimit}
				locale={{
					// Options.jsx
					items_per_page: "Items por página",
					jump_to: "Saltar a",
					jump_to_confirm: "Saltar para confirmar",
					page: "Página",
					// Pagination.jsx
					prev_page: "Página anterior",
					next_page: "Página siguiente",
					prev_5: "",
					next_5: "",
					prev_3: "",
					next_3: ""
				}}
			/>
		</div>
	);
};

export default Paginator;



// WEBPACK FOOTER //
// ./src/components/Paginator/Paginator.js